export const i18n = {
    //导航菜单
    lang: "en",
    coname: "Rank AI",
    company: "Anhui RankAI Technology Co., Ltd.",
    homePage: "Home",
    products: "Products",
    solutions: "Solutions",
    apps: "Applications",
    news: "News",
    introduction: "Company Introduction",
    cases: "Application Cases",
    ai: "AI",
    case: "Case",
    about: "About",
    //首页
    welcome: "Intelligent service expert by your side",
    bannerText: {
        first: "Digital Service Life",
        second: "Technology creates the future"
    },
    caseTitle: "Industrial application products",
    caseCards: [{
            img: require("../assets/images/home/yejin.jpg"),
            title: "Iron and Steel Metallurgy",
            text: "Steel claw crack detection, steel claw deformation detection, residual electrode tracking temperature measurement",
            index: 0,
        },
        {
            img: require("../assets/images/home/jiankong.jpg"),
            title: "Security Monitoring",
            text: "Fireworks identification, intrusion detection, instrument degree identification, helmet detection",
            index: 5,
        },
        {
            img: require("../assets/images/home/lingjian.jpg"),
            title: "Processing and Manufacturing",
            text: "Copper tube defect detection, yarn roll identification points, PVC film model identification",
            index: 12,
        },
        {
            img: require("../assets/images/home/yaoyong.jpg"),
            title: "Pharmaceutical Packaging",
            text: "Defect detection of medical aluminum tube",
            index: 9,
        },
        {
            img: require("../assets/images/home/shiping.jpg"),
            title: "Food Testing",
            text: "Spice bag oil leak detection, food package batch number detection",
            index: 10,
        },
    ],
    more:"More",
    proTitle: "Company Advantages",
    proCards: [{
            icon: require('../assets/images/home/jiegou.png'),
            title: "Structured Design",
            text: "Mature and efficient product design structure, saving time and improving efficiency"
        },
        {
            icon: require('../assets/images/home/dingzhi.png'),
            title: "Customized Design",
            text: "Design exclusive visual equipment matching for different testing needs"
        },
        {
            icon: require('../assets/images/home/data.png'),
            title: "Big Data Analysis",
            text: "Use big data analysis, research and judgment to provide customers with auxiliary decision-making"
        },
        {
            icon: require('../assets/images/home/working.png'),
            title: "Ready to use",
            text: "Hardware and software matching, installation and debugging completed at one time"
        },
        {
            icon: require('../assets/images/home/gaoxiao.png'),
            title: "Scientific Research Team",
            text: "Rely on the faculty of HKUST to provide the latest scientific research technology"
        },
        {
            icon: require('../assets/images/home/hangye.png'),
            title: "Industry Experience",
            text: "Products cover a wide range of industries, and the industry has rich experience"
        },
    ],
    partner: "Partner",
    partners: [{
            icon: require("../assets/images/home/kdgc.jpg"),
            url: "http://www.kdgcsoft.com/",
            name: "GUOCHUANG"
        },
        {
            icon: require("../assets/images/home/jcd.png"),
            url: "https://jcdtech.cn/",
            name: "JINGCHUANG",
        },
        {
            icon: require("../assets/images/home/hangtian.jpg"),
            url: "https://www.cast.cn//",
            name: "CAST",
        },
        {
            icon: require("../assets/images/home/zkd.jpg"),
            url: "https://www.ustc.edu.cn/",
            name: "USTC",
        },
        {
            icon: require("../assets/images/home/zsy.jpg"),
            url: "http://www.sinopec.com/",
            name: "SINOPEC",
        },{
            icon: require("../assets/images/home/sgccbz.jpg"),
            url: "http://www.ah.sgcc.com.cn/",
            name: "State Grid(BO ZHOU)",
        },
        {
            icon: require("../assets/images/home/wanji.png"),
            url: "http://www.wanjigroup.com/",
            name: "WANJI",
        },
        {
            icon: require("../assets/images/home/lckj.jpg"),
            url: "http://www.sinomagtech.com/",
            name: "SINOMAGTECH",
        },
        {
            icon: require("../assets/images/home/sh.png"),
            url: "https://www.shuanghui.net/",
            name: "SHUANGHUI",
        },
        {
            icon: require("../assets/images/home/qiye.png"),
            url: "",
            name: "ZHONGAN",
        },
    ],
    newsdata: [{
        title: "兰科获得国家高新科技企业称号！",
        text: "恭喜兰科获得国家高新科技企业称号！",
        time: "2022年10月30日",
        img: require('../assets/images/home/gaoxin.jpg')
    }, ],
    //产品中心
    prointro: "Rank AI deepens industry demand in various industries, combines artificial intelligence technology and visual image technology with industry content, and has developed many industrial intelligent visual products in mainstream industries such as metallurgy industry, food and medicine industry, manufacturing industry, security, etc.",
    protitle: "Industry Products",
    proback: "Product background",
    profunction: "Product Function",
    proadvance: "Product features",
    prositmap: "Product Composition",
    prostitles: [{
            title: "Iron and Steel Metallurgy",
            items: [{
                    title: "Steel claw welding crack detection",
                    index: 0,
                },
                {
                    title: "Steel claw deformation detection",
                    index: 1,
                },
                {
                    title: "Residual electrode tracking temperature measurement",
                    index: 2,
                },
                {
                    title: "Electrolyser Status Patrol Inspection",
                    index: 3,
                },
                {
                    title: "Electrolyser Leakage Patrol Inspection",
                    index: 4
                }
            ]
        },
        {
            title: "Security Monitoring",
            items: [{
                    title: "Pyrotechnic detection",
                    index: 5,
                },
                {
                    title: "Intrusion Detection",
                    index: 6,
                },
                {
                    title: "Equipment dial reading identification",
                    index: 7,
                },
                {
                    title: "Safety helmet detection",
                    index: 8,
                },
            ]
        },
        {
            title: "Pharmaceutical Packaging",
            items: [{
                title: "Inspection of medical aluminum tubes",
                index: 9,
            }, ]
        },
        {
            title: "Food Testing",
            items: [{
                    title: "Spice bag oil leakage detection",
                    index: 10,
                },
                {
                    title: "Food packaging lot number test",
                    index: 11,
                },
            ]
        },
        {
            title: "Processing and Manufacturing",
            items: [{
                    title: "Compressor copper pipe defect detection",
                    index: 12,
                },
                {
                    title: "Yarn roll identification points",
                    index: 13,
                },
                {
                    title: "PVC film model identification",
                    index: 14,
                },
                {
                    title: "Casserole defect detection",
                    index: 15,
                },
                {
                    title: "Single piece gluing detection",
                    index: 16,
                },
            ]
        }
    ],
    prosdata: [{
            title: "Crack in steel claw welding detection system",
            index: 0,
            text1: "The weld between the guide rod and the steel claw is easy to crack, which leads to excessive resistance and can not be used. Manual detection is easy to fail and unsafe. This system can replace manual detection, reduce missing and false detection, and improve efficiency.",
            text2: [
                "Track and capture the welding area of the steel claw",
                "Accurately identify the cracks at the welding,Position of the steel claw.",
                "Detect the number, length and width of cracks",
                "Communication with sorting device real time"
            ],
            text3: [
                "The identification accuracy of cracks is high, and the identification rate of cracks width greater than 1mm or length greater than 20mm reaches 99%.",
                "The identification time is 0.1s, which can meet the implementation control requirements."
            ],
            img: require("../assets/images/products/0_en.png"),
        },
        {
            title: "Deformation of Steel claw detection system",
            index: 1,
            text1: "Due to high current and corrosion, the steel claw will appear to bend deformation after being used for a while. After the deformation exceeds a specific range, it cannot be connected with the new anode carbon block and needs to be corrected. There is a significant error and danger when checking the deformation manually. This system can replace manual detection and improve the accuracy and accuracy.",
            text2: [
                "Track and capture the main part area of the steel claw.",
                "Accurately identify the deformed external claw of steel claw.",
                "Dynamic identification and refresh, mark in red for the position beyond."
            ],
            text3: [
                "The recognition algorithm takes less than 0.1s.",
                "High detection accuracy of deformation, up to 1mm."
            ],
            img: require("../assets/images/products/1_en.png"),
        },
        {
            title: "Residual electrode temperature detection and tracking system",
            index: 2,
            text1: "After being out of the electrolytic cell, the residual electrode needs to be cooled down to below 150 ℃ before cleaning. At present, the temperature measurement is mainly carried out by hand one by one, which has high potential safety hazards and low efficiency (It needs to arrange special temperature measurement personnel to get close to measure the temperature). This system replaces the work of temperature measurement personnel and has high efficiency and accuracy.",
            text2: [
                "Track and identify anode base.",
                "Accurately measure the maximum temperature of the anode base.",
                "Mark in red when the maximum temperature exceeds the threshold value.",
            ],
            text3: [
                "The results are automatically refreshed in real-time without the need for interaction.",
                "The accuracy of temperature results reaches 0.1 ℃."
            ],
            img: require("../assets/images/products/2_en.png"),
        },
        {
            title: "Status of electrolyser patrol inspection system",
            index: 3,
            text1: "The condition of the electrolytic cell needs to be checked regularly. Usually, the steel bar is extended into the reaction tank, and the state of the reaction tank is judged according to the color of the steel bar. Generally, two workers are required, one holding the steel bar and the other measuring, which is inefficient and dangerous. This system combined with patrol robot can replace manual patrol; it is safe and efficient.",
            text2: [
                "Identify the number of reaction tank, automatically bind and transmit the measurement results in real time.",
                "The robotic mechanical grab controls the steel bar to extend into the reaction tank, and the action is stable.",
                "Visual measurement ofVisual measurement of steel bar color and calculation of reaction tank statu the steel bar color and calculate the status of reaction tank.",
            ],
            text3: [
                "Only one person is required to operate to improve the patrol efficiency.",
                "Patrol inspectors do not need to touch the high temperature area, with good safety.",
                "The robot expands and contracts automatically to measure temperature with high efficiency.",
                "The measurement algorithm has high accuracy, accurate to 0.1mm.",
            ],
            img: require("../assets/images/products/3_en.png"),
        },
        {
            title: "Leakage of electrolyser detection system",
            index: 4,
            text1: "In the reaction process of the electrolytic aluminium reduction cell, the reaction solution may overflow, which can cause production accidents. Currently, the inspection of electrolytic cells is mainly carried out by patrol inspectors, which is prone to omission. This system can provide 24-hour leakage monitoring instead of manual patrol inspection.",
            text2: [
                "Real-time all-weather monitoring of the external state of the electrolytic cell and detection of leakage.",
                "Monitoring and detection records can be stored for reference.",
                "In case of leakage, give an audible and visual alarm immediately.",
            ],
            text3: [
                "Higher detection and analysis efficiency."
            ],
            img: require("../assets/images/products/4_en.png"),
        },
        {
            title: "Smoke fire identification",
            index: 5,
            text1: "Pyrotechnic detection is one of the most common functions in security monitoring.",
            text2: [
                "Real-time identification of smoke and flame in the designated area of the monitoring screen.",
                "Display the positioning feature box and feature confidence rate of fireworks.",
                "After detecting fireworks, start the alarm and transmit data.",
            ],
            text3: [
                "Dynamic identification without delay.",
                "High recognition accuracy (99.8%), low false alarm rate (below 10%).",
                "Adapt to various scenes during the day and night, rainy days and sunny days.",
            ],
            img: require("../assets/images/products/5_en.png"),
        },
        {
            title: "Intrusion detection",
            index: 6,
            text1: "Intrusion detection is used to detect whether there are people outside the situation invading the designated area.",
            text2: [
                "Carry out dynamic capture of the designated area, detect abnormal personnel and actions, and judge whether there is an intrusion.",
                "Linkage with safety equipment.",
                "Combined with face recognition, it locates intruders.",
            ],
            text3: [
                "Dynamic identification without delay.",
                "High recognition accuracy.",
                "For dark and daytime scenes.",
            ],
            img: require("../assets/images/products/6_en.png"),
        },
        {
            title: "Equipment dial reading identification",
            index: 7,
            text1: "Dial degree recognition is often used to monitor the real-time status of equipment in the plant.",
            text2: [
                "Capture the device dial in the monitoring screen automatically.",
                "Identify the degree of the dial pointer.",
            ],
            text3: [
                "Dynamic identification without delay.",
                "High recognition accuracy.",
                "Various numerical and point dials are supported, including thermometer, voltmeter, switch, and text box meter dials.",
            ],
            img: require("../assets/images/products/7_en.png"),
        },
        {
            title: "Hard hat identification",
            index: 8,
            text1: "The safety helmet must be correctly worn at dangerous operation sites. This system uses the real-time image obtained by the security camera to detect whether the safety helmet is worn by the person entering the site and whether it is standardized. In combination with face recognition, the system locates the person who does not wear the safety helmet according to the safety requirements and issues a warning.",
            text2: [
                "Real-time detection and monitoring screen to detect the wearing of personnel and helmets in the designated area, including those without helmets and those who do not wear helmets as required.",
            ],
            text3: [
                "In addition to wearing without wearing, it can detect various non-standard wearing conditions.",
                "Dynamic identification without delay.",
                "识High recognition accuracy for multi-angle video analysis.",
            ],
            img: require("../assets/images/products/8_en.png"),
        }, {
            title: "Medical aluminum tube detection system",
            index: 9,
            text1: "In the medical aluminium tube printing process, there will be unqualified printing, including missing words, broken strokes, ghosting, ink leakage, etc. Manual detection is inefficient and error-prone. This system can accurately detect the printing defects on the surface of aluminium tubes instead of manual inspection.",
            text2: [
                "Obtain a complete printed image of the aluminium tube surface.",
                "Detect printing defects such as missing characters, ghosting, ink leakage and broken strokes, send sorting signals, and control sorting equipment for screening.",
            ],
            text3: [
                "Adapts to various production line speeds.",
                "High detection and recognition accuracy, up to 95%."
            ],
            img: require("../assets/images/products/9_en.png"),
        }, {
            title: "Condiment bag oil leakage detection system",
            index: 10,
            text1: "The oil condiment bags will leak when packed; the leaking condiment bags need to be sorted out. At present, manual sorting is inefficient and easy to miss inspection. This system can automatically capture and detect the condiment bag's oil leakage instead of manual sorting to improve efficiency.",
            text2: [
                "Automatic tracking and capturing of condiment packages.",
                "Detect the oil leakage of the condiment package quickly.",
                "The detected results are refreshed in real-time.",
                "Communication with sorting equipment, sending sorting signals to sort automatically."
            ],
            text3: [
                "The minimum oil size that can be detected with high detection accuracy is 1mm.",
                "4000 bags can be sorted per hour."
            ],
            img: require("../assets/images/products/10_en.png"),
        },
        {
            title: "Food packaging batch number detection system",
            index: 11,
            text1: "Missing printing, wrong printing, position deviation and other situations occurred when printing the batch number on food packaging, which is an unqualified product and needs to be sorted. Currently, many batch numbers are checked manually, which makes it inefficient and easy to detect errors. This system can replace manual batch number detection, reduce missing and false detection, and improve efficiency.",
            text2: [
                "Capture food packaging bags automatically and locate the batch number.",
                "Identify the batch number and analyze it to determine whether there is missing, wrong printing or position deviation.",
                "Communication with sorting system to realize automatic detection and sorting.",
            ],
            text3: [
                "High efficiency, 4000 pieces per hour.",
                "High accuracy rate, accuracy rate reaches 99%."
            ],
            img: require("../assets/images/products/11_en.png"),
        },
        {
            title: "Compressor copper tube detection device",
            index: 12,
            text1: "After processing the compressor copper pipe, it must detect deformation, scratch, size discrepancy and other unqualified products. Manual detection is low efficient andand the rate of missed detection is high. This system can effectively complete the compressor copper tube defect detection work, instead of the quality inspection personnel.",
            text2: [
                "Customized and independently designed production line equipment, fully automated assembly line.",
                "Obtain the characteristics such as the appearance and size of copper tubes automatically, detect the defects such as pipe deformation, scratch, pier head deformation, end chamfer, pinch, serration, size discrepancy, etc",
                "When a non-conformity is detected, send a signal to control the sorting equipment.",
            ],
            text3: [
                "High detection accuracy up to 0.05mm.",
                "Most defects that are easy to occur in the processing of covered copper tubes.",
                "The detection efficiency is high, and the processing speed of a single device can reach 3600 pcs.",
            ],
            img: require("../assets/images/products/12_en.png"),
        },
        {
            title: "Yarn roll coounting system",
            index: 13,
            text1: "After being packed, the yarn rolls shall be counted in turn and then loaded and delivered. Manual counting is inefficient and prone to wrong counting or registration. This system is installed on the packing production line, which can automatically identify the yarn rolls in the carton and count them instead of manually counting.",
            text2: [
                "Receive point signals, automatically identify yarn rolls and count the total number.",
                "Judge whether to mix materials according to the size and colour of the yarn roll.",
                "The total statistics are saved in the history for reference.",
            ],
            text3: [
                "The processing time is 0.4s, and the accuracy rate can reach 100%.",
                "Adapt to the production line system and integrate into the information production system."
            ],
            img: require("../assets/images/products/13_en.png"),
        },
        {
            title: "PVC film type identification system",
            index: 14,
            text1: "The PVC film production line needs to be packed separately according to the model before packaging, so the model of PVC film needs to be determined before packaging. There are many types and similar patterns and colours of PVC film, which are difficult to distinguish. The packaging workers judge the classic films with a high error rate. This system can identify the PVC film type automatically and quickly, instead of judging by workers, to improve efficiency and accuracy.",
            text2: [
                "Receive the signal of the production line and start the identification function automatically.",
                "Obtain PVC film image automatically, and identify the model according to shading and colour.",
                "The identified results are automatically displayed, which is convenient for workers to split the package.",
            ],
            text3: [
                "The recognition time is less than 0.1s.",
                "High accuracy, recognition accuracy can reach 99.9%."
            ],
            img: require("../assets/images/products/14_en.png"),
        },
        {
            title: "Casserole defect detection system",
            index: 15,
            text1: "The quality inspection stage of the casserole mainly detects the defects such as pores, deformation and frying blanks on the bottom and side surfaces. Manual detection is inefficient and easy to miss. This system can detect each casserole position instead of manual detection through multiple machine positions and light sources.",
            text2: [
                "Use the upper and lower machine positions to detect defects such as pores, deformation and frying blanks on the bottom of the casserole.",
                "Use the horizontal machine position to cooperate with the rotary platform to continuously detect the defects such as pores, deformation, and frying blanks on the side of the casserole.",
                "Measure the diameter of the casserole.",
                "Dock sorting equipment and send sorting signals.",
            ],
            text3: [
                "High detection accuracy, up to about 98%.",
                "No blind angle in all directions."
            ],
            img: require("../assets/images/products/15_en.png"),
        },
        {
            title: "Single piece glue injection detection system",
            index: 16,
            text1: "After processing electrical components, it is necessary to check the glue injection status in the copper strip pin. Those without glue or glue overflow are unqualified. At present, glueing is mainly checked and sorted manually, which is inefficient and easy to miss. This system can automatically detect the glueing state instead of manual detection.",
            text2: [
                "Identify the copper strip pin position automatically and locate the glue injection port area.",
                "Check the state of the glue injection port to determine whether the glue is applied, and then determine whether the glue overflowed after the glue has been applied.",
                "Connect the sorting interface and send the sorting control signal.",
            ],
            text3: [
                "Capture, positioning, and detection automatically without control signal.",
                "The accuracy rate of detection results is high, and the accuracy rate can reach 99%."
            ],
            img: require("../assets/images/products/16_en.png"),
        }
    ],
    //解决方案
    solintro: "By analyzing the needs of fixed scenarios in the industry, Rank AI integrates intelligent visual products in different industries to provide professional solutions for scenarios in different industries. It can provide more comprehensive intelligent services for industrial customers, provide production efficiency, reduce costs and improve product quality.",
    refpro: "Products involved: ",
    soldatas: [{
            img: require("../assets/images/home/yejin.jpg"),
            title: "Intelligent Solution for Safety Production in Electrolytic Aluminum Plant",
            text: "This Solution provides electrolytic aluminum manufacturers with a complete set of safety production monitoring system. Through a series of intelligent products designed for quality inspection of electrolytic aluminum production process, it can achieve intelligent improvement of safety production, improve production efficiency, and also improve production safety for the factory. It is applicable to electrolytic aluminum plants of all sizes, and can also be customized for other metal factories.",
            text2: "Steel claw weld crack detection system,Steel claw deformation detection system,Residual electrode temperature detection and tracking system,Electrolytic tank status inspection system,Electrolytic tank leakage detection system",
        },
        {
            img: require("../assets/images/home/jiankong.jpg"),
            title: "Intelligent Security Monitoring Solution for Factory Substation",
            text: "This Solution provides a set of intelligent security monitoring scheme for various areas with high security requirements, including basic pyrotechnic detection, intrusion detection and helmet detection. In addition, it also provides the degree identification function of equipment and meters for the need to monitor the status of equipment in the industrial plant. The comprehensive and rich functions will greatly improve the security of the plant. It is applicable to various production plants or equipment workshops.",
            text2: "Smoke fire detection,Intrusion detection,Equipment dial reading,Helmet detection",
        },
    ],
    //智能应用
    aiContent: [{
            icon: "iconfont icon-pinglun",
            title: "Rank OnLine Review Content Intelligent Analysis Service Platform",
            text: "In order to improve the government's service level and keep abreast of the demands of the people in time, government portals often provide user opinion collection or comment functions. These opinion collection functions are open to the public and receive a large number of comments every day. Some of these comments are irrelevant. Some topics need to be addressed or resolved by the government. The government needs to identify the types of comments and deal with them in different categories. Due to the limited management manpower of the government, the manual sorting process alone is inefficient, and it is easy to miss events that need to be dealt with in time. The quality of government services is declining. In response to this problem, the content sentiment analysis system of Rank Online Review is based on TextCNN's deep learning text classification technology, which quickly classifies reviews according to content types, and provides multiple warning methods for problems that need to be dealt with in time. By using this system, government agencies can handle the problems reported by the people in a timely manner, which enhances the government agencies’ ability and efficiency in handling affairs, and has a positive effect on improving people’s livelihood.",
        },
        {
            icon: "iconfont icon-V",
            title: "Rank Multi-round Human-Machine Dialogue Service Platform",
            text: "With the continuous progress of society and the rapid development of artificial intelligence, service robots have been gradually applied to provide services for people in various scenarios in life. At present, related products are mostly services for open domain dialogues or other specific field dialogues. Robots are not effective and have poor scalability. How to improve the service level of service robots has become a content of social concern. In order to solve this problem, the Rank multi-round human-machine dialogue engine is based on machine learning methods and has targeted configuration industries. Corpus, such as the corpus of the banking service robot provides a large number of corpus for banking business, and the corpus of the hotel service robot provides corpus of hotel services, etc., which improves the dialogue ability and service quality of service robots, reduces human resources and improves service efficiency in various industries It is of great significance and value.",
        },
        {
            icon: "iconfont icon-tuxingtuxiangchuli",
            title: "Rank Composition Intelligent Identification System",
            text: "In geological research, analyzing and classifying rock slices through a microscope is a particularly important task. At present, the traditional method of analyzing the slice images of carbonate rock and sandstone samples is manual. Professional researchers Observe and shoot corresponding microscopic images under a polarizing microscope, and identify the structure and composition of the sample with the naked eye. Traditional analysis methods require professionals to interpret, which is time-consuming and labor-intensive, and training a professional requires a lot of money And time investment, and manual identification is easily affected by subjective factors, which affect the expert’s observation and identification results of rock slice samples. In recent years, the rapid development of digital image processing technology and artificial intelligence technology has used computers to perform professional rock slice images. Recognition and analysis are possible. The analysis of rock slice images is realized through a computer system. The computer system can quickly complete the analysis of a large number of rock slice images, and can detect many details that are invisible to the naked eye, which can assist researchers in preliminary analysis of a large number of images Classification and analysis. And the computer system can form a relatively uniform analysis standard, and can be quickly deployed and replicated, which can solve the problem of fewer professionals in the industry and a long training time. Therefore, a set of rock slice images has been developed Intelligent identification system has very practical value",
        }
    ],
    aiServiceContent: [{
            icon: "iconfont icon-chazhaobiaodanliebiao",
            title: "Text Intelligent Recognition and Analysis"
        },
        {
            icon: "iconfont icon-yuyin",
            title: "Speech Intelligent Recognition and Analysis"
        },
        {
            icon: "iconfont icon-tuxingtuxiangchuli",
            title: "Intelligent image recognition processing"
        }
    ],
    aiServiceText: "RankAI uses machine learning technology to deeply cultivate the needs of users in terms of intelligent perception and natural language, and cooperates with the Visual Computing Laboratory of the University of Science and Technology of China to develop a variety of artificial intelligence application products, including the 'Rank Online Intelligent Analysis Service Platform', 'Rank Multi-round Human-Machine Dialogue Service Platform', 'Rank Composition Intelligent Analysis System' and other products. RankAI has deep technology and experience accumulation in artificial intelligence technology and provides it to various industries Artificial intelligence application technology research and development services.",
    aiService: "Technical Solution",
    //关于
    introductionText1: "Anhui RankAI Technology Co., Ltd. (abbreviation: Lanke Intelligent) is a company dedicated to artificial intelligence, big data, cloud computing, Internet of Things and other technologies, providing artificial intelligence software products, solutions and technologies for various industries in the society Service technology company. The company relies on the University of Science and Technology of China to provide industry with defect detection technology and equipment based on image intelligent analysis. A group of technical talents who are proficient in artificial intelligence technology and have industry software development experience.",
    introductionText2: "RankAI has developed a series of machine vision intelligent products for different industries, such as Steel Claw Welding Crack Detection System, Steel Claw Deformation Detection System, Residual Electrode Temperature Detection and Tracking System, Spicy Bag Oil Leakage Detection System, Food Packaging Batch Number Detection System, by using machine learning technology, focusing on the needs of users in terms of intelligent perception and natural language and combining with a variety of intelligent equipment Yarn Roll Count System, PVC Film Type Identification System, Single Chip Gluing Detection System, Casserole Defect Detection System, Compressor Copper Tube Detection Device, etc. Lanke aims to combine the cutting-edge intelligent methods with the actual needs of the industry to provide more intelligent and practical products for more security and other industries, reduce production costs and improve production efficiency.",
    clickToOffers: "Join us now",
    contactUs: "Contact Us",
    address: "Company Address:",
    addressText: "Room 1008, Block A, J1 Floor, Phase 2, Innovation Industrial Park, High-tech Zone, Hefei, Anhui Province",
    busEmail: "Business Email:",
    busPhone: "Personnel Email:",
    busEmailText: "xumingyang@ranktek.cn",
    busPhoneText: "18119675306",
    companyInfo: "Get to know us",
    offers: "Join Us",
    //底边栏
    copyright: "Copyright©2021-2023",
    footerText: "Anhui RankAI Technology Co., Ltd. is a technology company dedicated to using artificial intelligence technology to provide software products, solutions and technical services for intelligent services to various industries in the society.",
    record: "Anhui ICP No. 2020019991-2",
    record2: "Anhui Public Network Security 34019202001631",
    follow: "Follow us",
    //其他
    ess: {
        content: "ESS is an application developed by Anhui Rank Intelligence to provide power safety knowledge learning and simulation examination.",
        mock: "Mock Exam",
        mockContent: "Online simulation, time limited exam.",
        day: "Daily Practice",
        dayContent: "Study anytime, anywhere and answer questions easily.",
        more: "More",
        moreContent: "Sequential exercise, special exercise, collection, wrong question set, ranking list...",
        android: "Android",
        androidContent: "Coming soon",
        androidVer: " Ver 1.0",
        ios: "iOS",
        iosContent: "Coming soon",
        iosVer: "Ver 1.0"
    },
    app_cas: "Internet Review Analysis",
    cas: {
        content: 'A set of government affairs public opinion comment analysis and classification service platform developed by Anhui Rank Intelligence on the Rank Online Review Content Intelligent Analysis Service Platform',
        link: 'Visit',
    },
}